import React from "react";
import { cn } from "utils/cn";
import { LoaderV2, LoaderMode, LoaderTheme } from "components/common/LoaderV2/LoaderV2";

type RouteFallbackProps = {
  label?: string;
  containerClassName?: string;
};

export const RouteFallback: React.FC<RouteFallbackProps> = ({ label, containerClassName }) => {
  return (
    <div
      className={cn(
        "w-full h-screen flex items-center justify-center select-none",
        containerClassName
      )}
    >
      <div className="relative flex flex-col items-center">
        <div className="absolute -inset-16 rounded-full bg-[radial-gradient(circle_at_center,rgb(var(--primary)/0.12),transparent_62%)]" />
        <LoaderV2
          mode={LoaderMode.inline}
          theme={LoaderTheme.brand}
          markSize={120}
          rotatingTexts={label ? [label] : ["Loading…", "Setting things up…", "Almost there…"]}
          textClassName="relative z-[1] text-muted-foreground text-sm"
        />
      </div>
    </div>
  );
};

export default RouteFallback;
